import { render, staticRenderFns } from "./deviceFunAuxLight2.vue?vue&type=template&id=8e021dc6&"
import script from "./deviceFunAuxLight2.vue?vue&type=script&lang=js&"
export * from "./deviceFunAuxLight2.vue?vue&type=script&lang=js&"
import style0 from "./deviceFunAuxLight2.vue?vue&type=style&index=0&id=8e021dc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports